/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRouter } from "next/navigation";

interface OfferItem {
  type: any;
  id: number;
  title?: string;
  description?: string;
  image: string;
  url?: string | null;
  banner_links?: Array<{
    id: number;
    linkable_type?: string | null;
    linkable_id?: number;
    banner_management_id?: number;
    type?: string;
  }>;
}

interface HomeOffersProps {
  offers?: OfferItem[];
}

function HomeOffers({ offers = [] }: HomeOffersProps) {
  const router = useRouter();
  type Slider = any;
  const sliderRef = useRef<Slider | null>(null);

  // Don't render if no offers
  if (!offers || offers.length === 0) {
    return null;
  }

  const settings = {
    infinite: offers.length > 9,
    slidesToShow: 9,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: offers.length > 5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: offers.length > 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: offers.length > 3,
        },
      },
    ],
  };

  const handleOfferClick = (offer: OfferItem) => {
    if (offer.url) {
      router.push(offer.url);
    } else if (offer.banner_links && offer.banner_links.length > 0) {
      // If there are product links, navigate to product category with offer title
      const productIds = offer.banner_links
        .filter(link => link.linkable_id !== undefined && link.linkable_type === "App\\Models\\Product")
        .map(link => link.linkable_id);

      if (productIds.length > 0) {
        const typeParam = offer.type ? `&type=${offer.type}` : "";
        router.push(`/product/product-category?productIds=${productIds.join(",")}${typeParam}`);
      } else {
        // Fallback to search with title if no valid productIds
        const offerTitle = offer.title || "Offers";
        const typeParam = offer.type ? `&type=${offer.type}` : "";
        router.push(`/product/product-category?type=offers&search=${encodeURIComponent(offerTitle)}${typeParam}`);
      }
    } else if (offer.title) {
      // Fallback to search with title
      const typeParam = offer.type ? `&type=${offer.type}` : "";
      router.push(`/product/product-category?type=offers&search=${encodeURIComponent(offer.title)}${typeParam}`);
    }
  };

  return (
    <>
      <section className="home_offers">
        <div className="container">
          <Slider ref={sliderRef} {...settings} className="offer_slider">
            {offers.map((offer) => (
              <figure
                key={offer.id}
                onClick={() => handleOfferClick(offer)}
                style={{ cursor: 'pointer', padding: '0 100px' }}
              >
                {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}> */}
                <img
                  src={offer.image}
                  alt={offer.title || offer.description || "offer"}
                // style={{ padding: '0 10px', display: 'block', maxWidth: '100%', height: 'auto' }} 
                />
                {/* {offer.title && <figcaption>{offer.title}</figcaption>} */}
                {/* </div> */}
              </figure>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}

export default HomeOffers;
